import PropTypes from 'prop-types'

import { DashboardModule, Form } from '@domain-group/suit-theme'

import { generateRedirectUrl } from '@domain-group/javascript-utils'

import { generateUrls } from '@hooks/useProvider'

import EntitySelector from '@components/EntitySelector'

const PublicationDetails = (props) => {
  const { publicationForm } = props

  const {
    entityState: {
      email,
      provider_id,
      publication_identifier,
      title,
    },
    errors,
    handlers,
    setEntityState,
  } = publicationForm

  const { editProviderUrl } = generateUrls({ id: provider_id })

  return (
    <DashboardModule title="Details">
      <Form padding="large">
        <Form.Row>
          <Form.Field label="* Title" errorMessage={errors.title}>
            <input type="text" name="title" value={title} {...handlers} />
          </Form.Field>

          <EntitySelector
            boxProps={{ marginTop: ['large', 0] }}
            callbacks={{
              selectItem: provider => setEntityState(
                { provider_id: provider ? provider.id : null, provider_price_list_id: null },
              ),
            }}
            entityKey="providers"
            errorMessage={errors.provider_id}
            goToHref={`${editProviderUrl}?redirect=${generateRedirectUrl()}`}
            label="* Provider"
            selectedItemId={provider_id}
          />
        </Form.Row>

        <Form.Row marginTop="large">
          <Form.Field label="Email">
            <input name="email" type="text" value={email} {...handlers} />
          </Form.Field>

          <Form.Field label="Publication ID" marginTop={['large', 0]}>
            <input name="publication_identifier" type="text" value={publication_identifier} {...handlers} />
          </Form.Field>
        </Form.Row>
      </Form>
    </DashboardModule>
  )
}

PublicationDetails.propTypes = {
  publicationForm: PropTypes.object.isRequired,
}

export default PublicationDetails
